import MuiTable from "@mui/material/Table";
const Table = MuiTable;
export default Table;
